import React from 'react';
import Redo from '../App/Redo';

function Platform() {
  return(
    <div className='paper'>
      <h2>Plateforme facilitatrice</h2>
      <li>Application du taux de TVA du pays de destination</li>
      <li>TVA collectée par la plateforme facilitatrice</li>
      <hr />
      <Redo />
    </div>
  )
}

export default Platform